import React, { useState, useEffect, useRef } from "react";
import { Heart, Trophy } from "lucide-react";
import "./Navbar.css";

// Debounce function
const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const Navbar = ({ score, lives, highScore }) => {
  const [animateScore, setAnimateScore] = useState(false);
  const debouncedHideAnimation = useRef(
    debounce(() => setAnimateScore(false), 800)
  ).current;

  useEffect(() => {
    if (score > 0) {
      setAnimateScore(true);
      debouncedHideAnimation();
    }
  }, [score, debouncedHideAnimation]);

  return (
    <div className="fixed top-0 left-0 right-0 text-white p-4 flex justify-between items-center z-10">
      <div className="flex flex-col space-y-4">
        <div className="flex">
          {[...Array(lives)].map((_, index) => (
            <Heart
              key={index}
              className="w-6 h-6 ml-1 text-red-500"
              fill="currentColor"
            />
          ))}
        </div>
        <div className="flex items-center bg-green-800 rounded-full px-3 py-1">
          <Trophy className="w-5 h-5 mr-2 text-yellow-400" />
          <span>{highScore}</span>
        </div>
        <div
          className={`flex transition-all font-extrabold text-4xl items-center rounded-full px-3 py-1 score-container ${
            animateScore ? "animate" : ""
          }`}
        >
          <span>{score}</span>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
